import { render, staticRenderFns } from "./AlertSubscriptionsDetails.vue?vue&type=template&id=61b2e253&"
import script from "./AlertSubscriptionsDetails.vue?vue&type=script&lang=js&"
export * from "./AlertSubscriptionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports